module.exports = __webpack_public_path__ + "static/media/building.0951b52d.svg";